import React, {ReactElement} from "react";
import {Box} from "@mui/material";
import {isFieldValid, isSchemaValid, PageStatus} from "ndr-designsystem";
import {useTranslation} from "react-i18next";
import {SectionRoot, SectionHeading, FieldGrid, TextInput, ListInput} from "../../../Components/fields";
import {DiscardButton} from "../../../Components/detailsView/DetailsView.styled";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import SchemaConstants from "../../../utils/schemaConstants";
import {
    setCallRetryDelays,
    setOnCallServiceEmail,
    setOnCallServicePhone,
} from "../store/TenantsSlice";
import {NumberSchema, OnCallTabSchema} from "../../../validations/TenantDetailsValidation";
import Config from "../../../app-config";
import callPhone from "../../../api/callService";

const OnCallTab = ({pageStatus}: {pageStatus: PageStatus}): ReactElement => {
    const dispatch = useAppDispatch();
    const isEditing = pageStatus === PageStatus.EDIT
    const isAdding = pageStatus === PageStatus.ADD
    const { currentTenant: tenant} = useAppSelector(state => state.Tenants)
    const {t} = useTranslation("tabels")
    const onCallTabSchema = OnCallTabSchema(isAdding);

    const HandleTestActivation = async (): Promise<void> => {
        if (tenant?.onCallServicePhone) {
            await callPhone(tenant.onCallServicePhone, Config.callService.message);
        }
    }

    return (
        <SectionRoot>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
                <Box>
                    <SectionHeading>{t("tenantDetails.tabs.onCall")}</SectionHeading>
                    <FieldGrid>
                        <TextInput
                            label={t("tenantDetails.onCallServiceEmail")}
                            value={tenant?.onCallServiceEmail}
                            isEditing={isEditing || isAdding}
                            required={isAdding}
                            onChange={(onCallServiceEmail) => dispatch(setOnCallServiceEmail(onCallServiceEmail))}
                            checkValue={onCallServiceEmail => isFieldValid(onCallTabSchema, [SchemaConstants.onCallServiceEmail], { onCallServiceEmail })}
                        />
                        <TextInput
                            label={t("tenantDetails.onCallServicePhone")}
                            value={tenant?.onCallServicePhone}
                            isEditing={isEditing || isAdding}
                            required={isAdding}
                            maxLength={15}
                            onChange={(onCallServicePhone) => dispatch(setOnCallServicePhone(onCallServicePhone))}
                            checkValue={onCallServicePhone => isFieldValid(onCallTabSchema, [SchemaConstants.onCallServicePhone], { onCallServicePhone })}
                        />
                    </FieldGrid>
                </Box>

                <ListInput
                    title={t('tenantDetails.callRetryDelays')}
                    elements={tenant?.callRetryDelays}
                    isEditing={isEditing || isAdding}
                    inputType="number"
                    canReorder
                    onChange={(callRetryDelays) => dispatch(setCallRetryDelays(callRetryDelays.map(Number)))}
                    checkValue={val => isSchemaValid(NumberSchema(), Number(val) as any)}
                    addButtonText={t("common:add_new")}
                    emptyText={t("common:no_records_text")}
                />

                {!!tenant?.onCallServicePhone?.length && !isEditing && !isAdding &&
                    <Box>
                        <DiscardButton onClick={HandleTestActivation}>
                            {t("tenantDetails.TestActivation")}
                        </DiscardButton>
                    </Box>
                }
            </Box>
        </SectionRoot>
    )
}

export default OnCallTab;
